import { dispatch } from '../store'
import { SET_EXPERIENCE } from '../reducers/experience'

export const fetchExperience = async () => {
  const experience = [
    { _id: 1, name: '0-2 ans', min: 0, max: 2 },
    { _id: 2, name: '2-7 ans', min: 2, max: 7 },
    { _id: 3, name: '7 ans et +', min: 7, max: 99 },
  ]
  dispatch({
    type: SET_EXPERIENCE,
    payload: experience,
  })
}
